export default "__VITE_ASSET__D87FH9a3__"